document.addEventListener('DOMContentLoaded', function () {
  const allinputfields = document.querySelectorAll('.main-products-select');
  if(allinputfields){
    allinputfields.forEach(inputradioel => {
      inputradioel.checked = false;
      inputradioel.removeAttribute('checked');
      console.log('removed');
    });
  }

  const deliverytypebuttons = document.querySelectorAll('.custom-header-deliver-btn');
  const overlay = document.getElementById('deliveryOverlay');

  if (deliverytypebuttons.length && overlay) {
    deliverytypebuttons.forEach((button) => {
      button.addEventListener('click', function () {
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    });
  }

  const allLabelRadio = document.querySelectorAll('.tiffin-prod-radio-label');
  if(allLabelRadio){
    allLabelRadio.forEach(lableradio => {
      lableradio.classList.remove('active');
      console.log('removed');
    });
  }

  const cartInputnote = document.querySelector('.cart-note-input');
  if(cartInputnote){
    const inputVal = cartInputnote;
    const cartattributeinput = document.querySelector('#cart-note-attr');
    if (cartattributeinput) {
      cartattributeinput.value = inputVal;
    }
  }
});

document.addEventListener('DOMContentLoaded', async function() {
  // Check for an explicit cart clearance flag.
  const shouldClear = await fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      return cart.attributes?.cartCleared === 'true';
    });

  if (shouldClear) {
    await fetch('/cart/clear.js', { method: 'POST' });
    localStorage.removeItem('selectedTiffins');

    // Remove the attribute after clearing.
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: { cartCleared: null }
      })
    });
  }
});